"use client";

import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "components/ui/skeleton";
import { getAPIClient } from "services/axios";
import { getAwardsData } from "shared/partnerPublic";

import Slider from "./slider";

export default function PartnerAwardsSlider({ slug }: { slug: string }) {
  const { data = [], isLoading } = useQuery({
    queryKey: [`partner-public-${slug}-awards`],
    queryFn: async () => {
      const result: any = await getAPIClient().get(
        `/partner/public/${slug}/awards`
      );
      if (!result.data) return [];
      return getAwardsData(result.data.awards, result.data.accreditations);
    },
    refetchOnWindowFocus: false,
  });

  return isLoading ? (
    <div className="box-border bg-white rounded-md w-full h-[250px] px-20 py-4">
      <Skeleton className="w-full h-full" />
    </div>
  ) : data.length > 0 ? (
    <Slider gallery={data} imgObjectFit="contain" />
  ) : null;
}
